import { useEffect, useState } from 'react';
import type { User } from '@twilio/conversations';
import { getTwilioUser } from 'app/services/twilio/client';

export default function useTwilioUser() {
  const [user, setUser] = useState<User>();

  useEffect(() => {
    getTwilioUser().then(setUser);
  }, []);

  return user;
}
